import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useState } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { min3CharValidator } from "../../components/formFields/CommonValidator";
import { IActivityTimeline } from "./activitiesModal";
import { Button } from "@progress/kendo-react-buttons";
import FormTextArea from "../../components/formFields/FormTextArea";
import FormImageUpload from "../../components/formFields/FormImageUpload";
// import ShadowCard from "../../components/common/ShadowCard";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";

const ActivityTimelineArray = (
  fieldArrayRenderProps: FieldArrayRenderProps,
) => {
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const dispatch = useAppDispatch();

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("deletetimelinedialog"));
    setDeleteIndex(index);
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps],
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        ID: null,
        Title: "",
        Time: "",
        Description: "",
        TimelineImage: "",
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <>
      <GridLayoutItem
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography.h5>Activity Timeline</Typography.h5>
        <div>
          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add Timeline
          </Button>
        </div>
      </GridLayoutItem>
      {dialogName === "deletetimelinedialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Timeline"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Timeline?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <GridLayoutItem
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        {fieldArrayRenderProps.value &&
          fieldArrayRenderProps.value.length > 0 &&
          fieldArrayRenderProps.value?.map(
            (ActivityTimeline: IActivityTimeline, index: number) => (
              <div
                key={index}
                style={{
                  // marginRight: 30,
                  // padding: 10,
                  border: "1px solid orange",
                  borderRadius: "8px",
                }}
              >
                <GridLayout
                  style={{
                    marginRight: 30,
                    padding: 10,
                    // border: "1px solid orange",
                    // borderRadius: "8px",
                  }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "calc((100% - 30px) / 3)" },
                    { width: "calc((100% - 30px) / 3)" },
                    { width: "calc((100% - 30px) / 3)" },
                    { width: "30px" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`ActivityTimeline.${index}.Title`}
                      label="Activity Name"
                      placeholder="Activity Name"
                      component={FormTextField}
                      validator={min3CharValidator}
                      astrike={true}
                    />
                    <Field
                      name={`ActivityTimeline.${index}.Time`}
                      label="Activity Time"
                      placeholder="Activity Time"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`ActivityTimeline.${index}.Description`}
                      label="Description"
                      component={FormTextArea}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`ActivityTimeline.${index}.TimelineImage`}
                      justifyContent="start"
                      label="TimelineImage"
                      type="file"
                      alternateName="Timeline Image"
                      component={FormImageUpload}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem style={{ textAlign: "center" }}>
                    <IconButton
                      onClick={() => handleOpenDeleteDialog(index)}
                      disabled={fieldArrayRenderProps?.value?.length === 1}
                      themeColor={"error"}
                      size={"small"}
                      fillMode={"solid"}
                      type="button"
                      style={{
                        height: 30,
                        width: 30,
                      }}
                      icon={MdDelete}
                      iconClassName="absolute-position"
                      iconStyle={{ fontSize: "24px" }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </div>
            ),
          )}
      </GridLayoutItem>
    </>
  );
};

export default ActivityTimelineArray;
